<script lang="ts">
	import { Select } from "flowbite-svelte-v1";
	import { boolOptionFalse, boolOptionTrue } from "#lib/boolean.js";

	interface Props {
		displayValue: string;
		onSelect: (value: boolean, event: Event) => void;
		invalid?: boolean;
		disabled?: boolean;
		id?: string;
		dataActionName: string;
		placeholder?: string;
		onblur?: (e: FocusEvent) => void;
	}

	let { displayValue, onSelect, invalid = false, disabled = false, id, dataActionName, placeholder = "Select from dropdown", onblur }: Props = $props();

	function selectValue(value: boolean, event: Event) {
		onSelect(value, event);
	}
</script>

<Select color={invalid ? "red" : null} {id} data-action-name={dataActionName} {placeholder} value={displayValue?.toLowerCase()} {disabled} {onblur} onchange={e => selectValue((e.target as HTMLSelectElement).value === "true", e)}>
	<option value="true">{boolOptionTrue}</option>
	<option value="false">{boolOptionFalse}</option>
</Select>
